import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
const benefits = ['Build vehicles and robots from scratch', 'Illustrated step-by-step instructions', 'Difficulty levels: easy, intermediate & advanced', 'STEM skills: engineering, logic & creativity', 'New projects added regularly', 'Perfect for solo play or parent-child time'];
const projects = [{
  img: 'https://cdn.magicpatterns.com/uploads/cBBDxnMb4mJFhDnHyQDyxY/IMG_1070.png',
  alt: 'Creative project with a bottle and paper clips',
  tone: 'bg-coral-light'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/85ppJUoEtmvkUbWcpaDyq7/IMG_1069.webp',
  alt: 'Cardboard elevator with a glowing traffic light',
  tone: 'bg-sky-light'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/acBuwab2CXMr2jfQVqrpi6/IMG_1068.webp',
  alt: 'Programmable robot arm',
  tone: 'bg-sunshine-light'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/oURkoCn4YJBQPNbRdnBCWU/IMG_1067.png',
  alt: 'Cardboard water dispenser',
  tone: 'bg-mint-light'
}, {
  img: 'https://cdn.magicpatterns.com/uploads/wvbckmE64dGniQpkQvKqY8/IMG_1066.png',
  alt: 'Mechanical robot hand',
  tone: 'bg-brand-light'
}];
export function ProjectsCarousel() {
  const prefersReducedMotion = useReducedMotion();
  const loopedProjects = [...projects, ...projects];
  return <section className="w-full overflow-hidden bg-white py-16 sm:py-24" data-id="element-154" data-mp="2l63z7ybmrgc4">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-155" data-mp="2q4nljzu4yu50">
        <SectionHeading eyebrow="What your child gets" title={<>100+ projects that really work</>} subtitle="Every project is tested, illustrated, and written in simple language your child can follow — alone or together with you." data-id="element-156" data-mp="2c3l09paytnv5" />
      </div>

      <div className="mt-12 w-full overflow-hidden" aria-label="A selection of MakerLab projects" data-id="element-157" data-mp="fb182qggn2y7">
        <motion.div className="flex w-max gap-3 px-1 sm:gap-5" animate={prefersReducedMotion ? undefined : {
        x: ['0%', '-50%']
      }} transition={prefersReducedMotion ? undefined : {
        duration: 34,
        ease: 'linear',
        repeat: Infinity
      }} data-id="element-158" data-mp="cww4iu294uzp">
          {loopedProjects.map((project, index) => <div key={`${project.alt}-${index}`} aria-hidden={index >= projects.length} className={`h-36 w-24 flex-none overflow-hidden rounded-2xl border border-ink/10 shadow-sm sm:h-48 sm:w-36 ${project.tone}`} data-id="element-159" data-mp="rlskddajvcav" data-mpi={index}>
              <img src={project.img} alt={index < projects.length ? project.alt : ''} className="h-full w-full object-cover" data-id="element-160" data-mp="1fb4po22rb07w" />
            </div>)}
        </motion.div>
      </div>

      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-161" data-mp="1hxduxpxz468h">
        <ul className="mt-12 grid gap-x-8 gap-y-4 rounded-3xl border border-ink/10 bg-brand-light p-8 sm:grid-cols-2" data-id="element-162" data-mp="1mvfc25bu9vhb">
          {benefits.map((benefit, index) => <li key={benefit} className="flex items-start gap-3 text-sm font-medium text-ink" data-id="element-163" data-mp="1wsjxg2xv1mx2" data-mpi={index}>
              <span className={`mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full ${['bg-brand text-white', 'bg-sky text-ink', 'bg-coral text-ink', 'bg-mint text-ink', 'bg-brand text-white', 'bg-sky text-ink'][index]}`} data-id="element-164" data-mp="20t401m17diql">
                <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-165" data-mp="2kj60fft0ch07" />
              </span>
              {benefit}
            </li>)}
        </ul>
      </div>
    </section>;
}